// theme.js
import { createTheme } from "@mui/material/styles";
import { PulseColors } from "./appColor";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: PulseColors.primary },
    secondary: { main: PulseColors.secondary }, // login/neutral actions
    error: { main: PulseColors.error },
    warning: { main: PulseColors.warning },
    info: { main: PulseColors.info },
    background: {
      default: PulseColors.secondaryLight, // scaffold background
      paper: PulseColors.backgroundLight, // cards/panels
    },
    text: {
      primary: PulseColors.dark,
      secondary: "#475569", // subtle text on light
    },
    divider: PulseColors.dividerLight,
  },
  components: {
    // Example: AppBar & Buttons mirror your Flutter example
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: PulseColors.primary,
          color: PulseColors.backgroundLight,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // default button styling to keep usage consistent
          // (contained buttons pick palette.primary/secondary automatically)
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: PulseColors.primary },
    secondary: { main: PulseColors.secondary },
    error: { main: PulseColors.error },
    warning: { main: PulseColors.warning },
    info: { main: PulseColors.info },
    background: {
      default: PulseColors.backgroundDark, // scaffold background
      paper: "#161A20", // slightly raised surface
    },
    text: {
      primary: PulseColors.textLight,
      secondary: "#B2B7BF",
    },
    divider: PulseColors.dividerDark,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: PulseColors.primary,
          color: "#CFC3B5", // subtle, readable on blue
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // dark mode keeps to palette
        },
      },
    },
  },
});
